import React from "react";
import PageShell from "../components/PageShell";
import Services from "../components/Services";
import Pricing from "../components/Pricing";

export default function ServicosPage() {
  return (
    <PageShell testId="page-servicos">
      <Services />
      <Pricing />
    </PageShell>
  );
}
